import { useSelector } from 'react-redux';
import { Button, Container, EmptyState, Image } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import * as sessionSelectors from 'state/session/selectors';
import { STATIC_ASSETS_URL } from 'constants/index';
import ErrorHeader from 'components/ErrorHeader';
import StackTrace from '../StackTrace';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const AppError = _ref => {
  let {
    error,
    errorInfo,
    handleRetry
  } = _ref;
  const translate = useTranslate('error_page');
  const isGod = useSelector(sessionSelectors.getIsUserGod);
  return /*#__PURE__*/_jsxs("div", {
    className: "fullpage-layout u-background-white u-fill-viewport",
    children: [/*#__PURE__*/_jsx(ErrorHeader, {}), /*#__PURE__*/_jsx("main", {
      className: "site",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [/*#__PURE__*/_jsx(EmptyState, {
          image: /*#__PURE__*/_jsx(Image, {
            src: "".concat(STATIC_ASSETS_URL, "/assets/error-page/404-rack.svg")
          }),
          title: translate('client_error.title'),
          body: translate('client_error.body'),
          action: /*#__PURE__*/_jsx(Button, {
            styling: Button.Styling.Filled,
            onClick: handleRetry,
            children: translate('actions.retry')
          })
        }), isGod && /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(StackTrace, {
            error: error,
            errorInfo: errorInfo
          })
        })]
      })
    })]
  });
};

export default AppError;